import BAboutFirstBlockEuroBox from './BAboutFirstBlockEuroBox'

export default BAboutFirstBlockEuroBox
